import Drawer from "devextreme-react/drawer";
import ScrollView from "devextreme-react/scroll-view";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Footer, Header, SideNavigationMenu } from "../../components";
import "./base-layout.scss";
import { useScreenSize } from "../../utils/media-query";
import { Template } from "devextreme-react/core/template";
import { useMenuPatch } from "../../utils/patches";
import { PopupTitleWithIcon } from "../../components/popup-title-with-icon/popup-title-with-icon";
import { Popup } from "devextreme-react/popup";
import { useAuth } from "../../contexts/auth";
import notify from "devextreme/ui/notify";
import {generateFingerpint} from "../../api/auth";
import {stopImpersonate} from "../../api/administration";
import StorageService from "../../services/storage.service";

const BaseLayout = ({ title, children }) => {
  const { timerWorks, setTimerWorks, user } = useAuth();
  // const scrollViewRef = useRef();
  const history = useHistory();
  let { isXSmall, isLarge } = useScreenSize();
  // для скрытия меню на главной (#/home) после логина и при обращении к корню и при f5 на главной
  let home3 =
    window.location.hash === "#/home" ||
    window.location.hash === "#/" ||
    window.location.hash === "#/login";
  if (home3) {
    isXSmall = true;
    isLarge = false;
  }
  const [patchCssClass, onMenuReady] = useMenuPatch();
  const [firstHome, setFirstHome] = useState("");
  const url = [
    "#/price-analysis",
    "#/energoobjects",
    "#/docs",
    "#/energoobjects",
    "#/pokazania-new",
    "#/pokazania-history",
    "#/consumption-analysis",
    "#/consumption-history",
    "#/range-volumes-edit",
    "#/range-volumes-history",
  ];

  const { syncUserData, setAuth, setCountDogovors, setSelectedDog, impersonate } = useAuth();

  /* eslint-disable */
  useEffect(() => {
    setFirstHome(window.location.hash);
    //если переход с другого урла первый раз, закрываем меню
    if (window.location.hash === "#/home" && firstHome !== "#/home") {
      // записываем текущий чтобы можно было открыть
      setFirstHome(window.location.hash);
      setMenuStatus(MenuStatus.Closed);
    }
  }, [window.location.hash]);

  /* eslint-enable */

  const [menuStatus, setMenuStatus] = useState(
    isLarge ? MenuStatus.Opened : MenuStatus.Closed
  );

  const toggleMenu = useCallback(({ event }) => {
    setMenuStatus((prevMenuStatus) =>
      prevMenuStatus === MenuStatus.Closed
        ? MenuStatus.Opened
        : MenuStatus.Closed
    );
    event.stopPropagation();
  }, []);

  const exitImpersonateClick = useCallback(async () => {
    const fingerprint = await generateFingerpint()
    const originalUserId = JSON.parse(window.localStorage.getItem( "originalUser" ))?.id
    const targetUserId = JSON.parse(window.localStorage.getItem( "lastUser" ))?.id
    const resStop = await stopImpersonate(originalUserId, targetUserId, fingerprint);
    if (resStop.isOk) {
      // Drop impersonated user's dog before restoring admin session
      StorageService.removeLocalDodovor()
      setSelectedDog(null)
      StorageService.setLocalAuth( fingerprint )
      setAuth( resStop.data )
      setCountDogovors( resStop.data.dogovors )
      window.localStorage.removeItem( "originalUser" )
      //window.localStorage.setItem("originalUser",resStop.res.originalUser)
      notify( resStop.res.message, 'success', 5000 );
      await syncUserData()
      history.push('/admin-impersonation')
    }
    else {
      notify( resStop.message, 'error', 10000 );
    }
  }, [history, setAuth, setCountDogovors, setSelectedDog, syncUserData]);

  const temporaryOpenMenu = useCallback(() => {
    setMenuStatus((prevMenuStatus) =>
      prevMenuStatus === MenuStatus.Closed
        ? MenuStatus.TemporaryOpened
        : prevMenuStatus
    );
  }, []);

  const onOutsideClick = useCallback(() => {
    setMenuStatus((prevMenuStatus) =>
      prevMenuStatus !== MenuStatus.Closed && !isLarge
        ? MenuStatus.Closed
        : prevMenuStatus
    );
  }, [isLarge]);

  const onNavigationChanged = useCallback(
    ({ itemData: { path }, event, node }) => {
      if (menuStatus === MenuStatus.Closed || !path || node.selected) {
        event.preventDefault();
        return;
      }
      history.push(path);
      //scrollViewRef.current.instance.scrollTo(0);
      if (!isLarge || menuStatus === MenuStatus.TemporaryOpened) {
        setMenuStatus(MenuStatus.Closed);
        event.stopPropagation();
      }
    },
    [history, menuStatus, isLarge]
  );

  const handleHeaderClick = useCallback((e) => {
    if (menuStatus === MenuStatus.Closed) {
      e.preventDefault();
      return;
    }
    if (!isLarge || menuStatus === MenuStatus.TemporaryOpened) {
      setMenuStatus(MenuStatus.Closed);
      e.stopPropagation();
    }
  }, [menuStatus, isLarge]);

  const hidePop = () => {
    setTimerWorks(false);
  };

  return (
    <div className={"base-layout"} >
      <Header
          handleHeaderClick={handleHeaderClick}
        className={"layout-header"}
        menuToggleEnabled
        toggleMenu={toggleMenu}
        title={title}
      />
      <Drawer
        className={["drawer", patchCssClass].join(" ")}
        position={"before"}
        closeOnOutsideClick={onOutsideClick}
        openedStateMode={isLarge ? "shrink" : "overlap"}
        revealMode={isXSmall ? "slide" : "expand"}
        minSize={isXSmall ? 0 : 60}
        maxSize={265}
        shading={!isLarge}
        opened={menuStatus !== MenuStatus.Closed}
        template={"menu"}
      >
        {" "}
        {/*для Графаны делаем 100% ширину*/}
        <div
          className={
            !home3 && !isXSmall
              ? (!url.includes(window.location.hash)
                  ? window.localStorage.getItem("dx-theme-class")
                  : "container-fluid") ||
                (!url.includes(window.location.hash)
                  ? process.env.REACT_APP_NAME_ENV !== 'tatenergosbyt' ? "container-lg" : "container-fluid"
                  : "container-fluid")
              : "container-fluid-no-padding"
          }
        >
          <div  className={"layout-body with-footer"}>
            <div className={"content"}>
              {impersonate &&
              <div className="alert alert-primary mb-0" role="alert">
                Вы работаете под пользователем: { user.firstName ? user.firstName + ' ' + user.lastName : user.lastName }. Для возврата в режим администратора пройдите по ссылке&nbsp;
                 <a href='#/admin-impersonation' onClick={exitImpersonateClick} >Выйти в администрирование {impersonate}</a>.
              </div>
              }
              {React.Children.map(children, (item) => {
                return item.type !== Footer && item;
              })}
            </div>
            <div className={"content-block"}>
              {React.Children.map(children, (item) => {
                return item.type === Footer && item;
              })}
            </div>
          </div>
        </div>
        <Template name={"menu"}>
          <SideNavigationMenu
            compactMode={menuStatus === MenuStatus.Closed}
            selectedItemChanged={onNavigationChanged}
            openMenu={temporaryOpenMenu}
            onMenuReady={onMenuReady}
          ></SideNavigationMenu>
        </Template>
      </Drawer>
      <Popup
        visible={timerWorks}
        dragEnabled={true}
        hideOnOutsideClick={true}
        showCloseButton={true}
        showTitle={true}
        title="Активация договора"
        maxWidth={400}
        maxHeight={"90%"}
        height={"auto"}
        onHiding={hidePop}
        titleRender={() =>
          PopupTitleWithIcon("dx-icon-info", "Активация договора", hidePop)
        }
      >
        <ScrollView width="100%" height="100%">
          Активация договора занимает от 10 секунд до 30 минут. Зависит от
          загруженности сервера. Если договор не появился в списке, обновите
          страницу через некоторое время.
        </ScrollView>
      </Popup>
    </div>
  );
};

const MenuStatus = {
  Closed: 1,
  Opened: 2,
  TemporaryOpened: 3,
};

export default BaseLayout;
